import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgDoorOpenRegular = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M9.556 13.222c.506 0 .916-.549.916-1.188s-.409-1.256-.916-1.256-.917.55-.917 1.222.412 1.222.917 1.222m2.444-11a1.3 1.3 0 0 0-.294.039l-7.333 1.9c-.581.143-.929.65-.929 1.227v14.556H1.917a.916.916 0 1 0 0 1.834H12c.675 0 1.222-.548 1.222-1.223V3.488c0-.717-.561-1.266-1.222-1.266m-.611 17.722H5.278V5.817l6.11-1.58zm10.694 0h-1.527V7.111a2.444 2.444 0 0 0-2.445-2.444h-3.667V6.5h3.667c.338 0 .611.273.611.611v13.444c0 .675.547 1.223 1.222 1.223h2.14a.917.917 0 0 0 0-1.834"
    }));
export default SvgDoorOpenRegular;
